<template>
    <div class="van-page">
        <van-sticky>
            <the-header title="事项办理部门" isShowArrow />
        </van-sticky>
        <div class="log-container">
            <div class="title">{{ itemName }}</div>
        </div>
        <div class="phone-detail">
            <div class="org">{{ result.ORG_NAME }}</div>
            <ul class="list-group">
                <li>
                    <span class="title">咨询电话：</span>
                    <span class="content" v-if="result.CONSULTINGPHONE">
                        <a :href="`tel:${result.CONSULTINGPHONE}`" v-if="result.CONSULTINGPHONE">{{ result.CONSULTINGPHONE
                        }}</a>
                    </span>
                    <span class="content" v-else>暂无数据</span>
                </li>
                <li>
                    <span class="title">窗口咨询：</span>
                    <span class="content">{{ result.WINDOW_ADDRESS || '暂无数据' }}</span>
                </li>
                <li>
                    <span class="title">咨询邮箱：</span>
                    <span class="content">{{ result.EMAIL || '暂无数据' }}</span>
                </li>
                <li>
                    <span class="title">投诉电话：</span>
                    <span class="content" v-if="result.COMPLAINTSHOTLINE">
                        <a :href="`tel:${result.COMPLAINTSHOTLINE}`" v-if="result.COMPLAINTSHOTLINE">{{
                            result.COMPLAINTSHOTLINE }}</a>
                    </span>
                    <span class="content" v-else>暂无数据</span>
                </li>
                <li>
                    <span class="title">投诉邮箱：</span>
                    <span class="content">{{ result.COMPLAINTEMAILADDRESS || '暂无数据' }}</span>
                </li>
                <li>
                    <span class="title">窗口投诉：</span>
                    <span class="content">{{ result.WINDOWCOMPLAINTADDRESS || '暂无数据' }}</span>
                </li>
                <li>
                    <span class="title">窗口名称：</span>
                    <span class="content">{{ result.NAME || '暂无数据' }}</span>
                </li>
                <li>
                    <span class="title">受理地点：</span>
                    <span class="content">{{ result.ADDRESS || '暂无数据' }}</span>
                </li>
                <li>
                    <span class="title">受理时间：</span>
                    <span class="content">{{ result.OFFICE_HOUR || '暂无数据' }}</span>
                </li>
            </ul>
        </div>
    </div>
</template>
  
<script>
import { getAllItemInfoByItemID } from '@/api/interface/phonebook'

export default {
    name: 'editLog',
    components: {
        'the-header': () => import('@/components/TheHeader')
    },
    data() {
        return {
            result: {},
            itemName: '',
            code: null
        }
    },
    created() {
        try {
            const href = location.href
            this.code = new Map()
            if (href.includes('?')) href.split('?')[1].split('&').forEach(item => {
                const temp = item.split('=')
                this.code.set(temp[0], temp[1].split('#')[0].includes('%') ? decodeURIComponent(temp[1].split('#')[0]) : temp[1].split('#')[0])
            });
        } catch (err) {
            console.log(err);
        }
    },
    methods: {
        checkDetail() {
            const instance = new getAllItemInfoByItemID({
                itemId: this.code.get('id')
            })
            instance
                .then((result) => {
                    this.result = {
                        ORG_NAME: result.data.ItemInfo[0].ORG_NAME,
                        WINDOW_ADDRESS: result.data.consult[0].WINDOW_ADDRESS,
                        CONSULTINGPHONE: result.data.consult[0].CONSULTINGPHONE,
                        EMAIL: result.data.consult[0].EMAIL,
                        WINDOWCOMPLAINTADDRESS: result.data.complain[0].WINDOWCOMPLAINTADDRESS,
                        COMPLAINTSHOTLINE: result.data.complain[0].COMPLAINTSHOTLINE,
                        COMPLAINTEMAILADDRESS: result.data.complain[0].COMPLAINTEMAILADDRESS,
                        ADDRESS: result.data.window[0].ADDRESS,
                        NAME: result.data.window[0].NAME,
                        WINDOW_NUM: result.data.window[0].WINDOW_NUM,
                        OFFICE_HOUR: result.data.window[0].OFFICE_HOUR,
                    }
                }).catch((err) => {
                    console.log(err);
                });
        },
    },
    mounted() {
        this.checkDetail();
        this.itemName = this.code.get('name');
    }
}
</script>
  
<style lang="less" scoped>
.log-container {
    padding: 16px;

    .title {
        font-size: 18px;
        margin-bottom: 16px;
    }
}

#log {
    font-size: 16px;
    padding-bottom: 200px;
}

.button {
    position: fixed;
    bottom: 5%;
    left: 50%;
    transform: translate(-50%, 0);
}

.phone-detail {
    padding: 0;
    background-color: #427afa;
    color: white;
    margin: 16px;
    border-radius: 15px;
    border: none;

    .org {
        font-size: 21px;
        padding: 16px;
    }
}

.list-group {
    background-color: white;
    padding: 16px;

    >li {
        display: flex;
        gap: 8px;
        color: #000;
        font-size: 14px;
        padding: 5px 0;
        border-bottom: 1px solid #e6e6e6;

        .title {
            flex: 3;
            display: block;
        }

        .content {
            flex: 8;
        }
    }

    >li:last-child {
        border: none;
    }
}</style>